export default "__VITE_ASSET__BDwGtbCI__"